/**
 *
 * LiveNewsSidebar
 *
 */

import React, { memo, FunctionComponent, useState, useMemo } from 'react';
import { StyledLiveNewsSidebar } from './styledComponents';
import arrorRightIcon from '../../assets/icons/arrow-right.svg';
import { StyledCard } from '../../global-styles';
import { useEventNews } from '../../api/useEventNews';
import { AppQueryParamsConfigMap } from '../../app/constants';
import { useQueryParams } from 'use-query-params';
import moment from 'moment';

interface IProps {
  expanded: boolean;
}

const LiveNewsSidebar: FunctionComponent<IProps> = ({ expanded }) => {
  const [{ e: eventId }] = useQueryParams(AppQueryParamsConfigMap);
  const [showMore, setShowMore] = useState(false);
  const [page, setPage] = useState(0);

  const { data: news } = useEventNews(eventId);

  const newsProcessed = useMemo(
    () => (showMore ? news : news?.slice(page, page + 1)),
    [showMore, news, page],
  );

  const handleArrowClick = (direction: number) => {
    setPage(page + direction);
  }

  if (!news?.length) {
    return null;
  }

  if (expanded) {
    return (
      <StyledLiveNewsSidebar showMore={showMore}>
        <div className="head">
          <div className="title">
            News Feed
            {showMore ? (
              <div className="counter">{news.length}</div>
            ) : (
              <div className="counter">
                {page + 1} of {news.length}
              </div>
            )}
          </div>
          {!showMore && news.length > 1 && (
            <div className="pager">
              <button
                className="btn-icon prev"
                style={{ opacity: !page ? 0.5 : 1 }}
                disabled={!page}
                onClick={() => handleArrowClick(-1)}
              >
                <img src={arrorRightIcon} alt="" />
              </button>
              <button
                className="btn-icon next"
                disabled={page === news.length - 1}
                style={{ opacity: page === news.length - 1 ? 0.5 : 1 }}
                onClick={() => handleArrowClick(1)}
              >
                <img src={arrorRightIcon} alt="" />
              </button>
            </div>
          )}
        </div>
        <div className="body">
          <StyledCard>
            {newsProcessed?.map((item) => (
              <div className="card-body mt-10" key={item.eventNewsItemId}>
                <div className="d-flex flex-column">
                  <div className="live-news-time">
                    {moment(item.createdDate).format('HH:mm')}
                  </div>
                  <div className="live-news-time-lbl">
                    {moment(item.createdDate).calendar(null, {
                      sameDay: '[Today]',
                      nextDay: '[Tomorrow]',
                      nextWeek: 'dddd',
                      lastDay: '[Yesterday]',
                      lastWeek: '[Last] dddd',
                      sameElse: 'DD/MM/YYYY',
                    })}
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <div className="live-news-event-lbl">Live News</div>
                  <div className="live-news-event">{item.description}</div>
                </div>
              </div>
            ))}
            {news.length > 1 && (
              <div className="card-footer">
                <button className="link" onClick={() => setShowMore(!showMore)}>
                  {showMore ? 'Show less' : 'Show more'}
                </button>
              </div>
            )}
          </StyledCard>
        </div>
      </StyledLiveNewsSidebar>
    );
  } else {
    return (
      <StyledCard className="card-vertical mb-15">
        <div className="card-body">
          <div className="txt fw-7 fs-16">
            News Feed
          </div>
        </div>
      </StyledCard>
    );
  }
};

export default memo(LiveNewsSidebar);
